"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ModalController = /** @class */ (function () {
    function ModalController($scope, $uibModalInstance, model) {
        var _this = this;
        this.$scope = $scope;
        this.$uibModalInstance = $uibModalInstance;
        this.model = model;
        this.closeModal = function (isValid, callback, data) {
            if (typeof isValid !== 'undefined') {
                if (isValid) {
                    callback(data);
                }
            }
            else {
                callback(data);
            }
        };
        this.ok = function (data, isValid) {
            _this.closeModal(isValid, _this.$uibModalInstance.close, data);
        };
        this.cancel = function (data, isValid) {
            _this.closeModal(isValid, _this.$uibModalInstance.dismiss, data);
        };
        $scope.modalMessageText = model.modalMessageText;
    }
    ModalController.prototype.$onInit = function () {
    };
    return ModalController;
}());
exports.ModalController = ModalController;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibW9kYWwuY29udHJvbGxlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm1vZGFsLmNvbnRyb2xsZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFFQTtJQW1CSSx5QkFBb0IsTUFBVyxFQUFVLGlCQUFzQixFQUFVLEtBQVU7UUFBbkYsaUJBRUM7UUFGbUIsV0FBTSxHQUFOLE1BQU0sQ0FBSztRQUFVLHNCQUFpQixHQUFqQixpQkFBaUIsQ0FBSztRQUFVLFVBQUssR0FBTCxLQUFLLENBQUs7UUFsQjVFLGVBQVUsR0FBRyxVQUFDLE9BQVksRUFBRSxRQUFhLEVBQUUsSUFBUztZQUN2RCxJQUFJLE9BQU8sT0FBTyxLQUFLLFdBQVcsRUFBRTtnQkFDaEMsSUFBSSxPQUFPLEVBQUU7b0JBQ1QsUUFBUSxDQUFDLElBQUksQ0FBQyxDQUFDO2lCQUNsQjthQUNKO2lCQUFNO2dCQUNILFFBQVEsQ0FBQyxJQUFJLENBQUMsQ0FBQzthQUNsQjtRQUNMLENBQUMsQ0FBQTtRQUVNLE9BQUUsR0FBRyxVQUFDLElBQVMsRUFBRSxPQUFZO1lBQ2hDLEtBQUksQ0FBQyxVQUFVLENBQUMsT0FBTyxFQUFFLEtBQUksQ0FBQyxpQkFBaUIsQ0FBQyxLQUFLLEVBQUUsSUFBSSxDQUFDLENBQUM7UUFDakUsQ0FBQyxDQUFBO1FBRU0sV0FBTSxHQUFHLFVBQUMsSUFBUyxFQUFFLE9BQVk7WUFDcEMsS0FBSSxDQUFDLFVBQVUsQ0FBQyxPQUFPLEVBQUUsS0FBSSxDQUFDLGlCQUFpQixDQUFDLE9BQU8sRUFBRSxJQUFJLENBQUMsQ0FBQztRQUNuRSxDQUFDLENBQUE7UUFHRyxNQUFNLENBQUMsZ0JBQWdCLEdBQUcsS0FBSyxDQUFDLGdCQUFnQixDQUFDO0lBQ3JELENBQUM7SUFFRCxpQ0FBTyxHQUFQO0lBQ0EsQ0FBQztJQUNMLHNCQUFDO0FBQUQsQ0FBQyxBQXpCRCxJQXlCQztBQXpCWSwwQ0FBZSJ9